//External
import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
//Internal
import { searchBrandVehicle } from "../../store/actions";
import {
  hrefURL,
  getRecentSearchList,
  get_cookie,
} from "../../utils";
import { useDispatch } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { debounce } from "lodash";

/*******************
@Purpose : Used for search bar
@Parameter : { currentLocationId, slug1, slug2, showMenu }
@Author : INIC
******************/
function SearchBar({
  currentLocationId,
  slug1,
  slug2,
  showMenu,
  setShowMenu,
  showAutofocus,
}) {
  const router = useRouter();
  const { slug } = router.query;
  const asPath = router.asPath;
  const is_mobile_app = get_cookie("is_mobile_app");

  const dispatch = useDispatch();
  const [searchTextData, setSearchTextData] = useState("");
  const [selectedData, setSelectedData] = useState("");

  const callApi = () => {
    setReload(true);
  };

  const [debouncedCallApi] = useState(() => debounce(callApi, 250));
  const [reload, setReload] = useState(false);
  const [recentSearchOptions, setRecentSearchOptions] = useState([]);
  const [makesOptions, setMakesOptions] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const myInputRef = useRef();
  const [isShowSearch, setIsShowSearch] = useState(false);

  useEffect(() => {
    if (isShowSearch && !showMenu) {
      window.addEventListener("click", function (e) {
        if (e?.target?.children[3]?.getAttribute("id") !== "close-search") {
          if (document.getElementById("search-results")?.contains(e.target)) {
          } else {
            setIsShowSearch(false);
            setShowMenu && setShowMenu(false);
          }
        } else {
          setIsShowSearch(false);
          setShowMenu && setShowMenu(false);
        }
      });
    }
  }, [isShowSearch, showMenu]);

  /*******************
  @Purpose : React Hook Used for focus select
  @Parameter : {}
  @Author : INIC
  ******************/
  useEffect(() => {
    if (showMenu) {
      focusSearchMobile();
    }
  }, [showMenu]);

  const groupedOptions = [
    {
      label: "Recently Viewed",
      options: recentSearchOptions,
    },
    {
      label: "Makes",
      options: makesOptions,
    },
    {
      label: "Vehicles",
      options: vehicleOptions,
    },
  ];

  // Search bar

  const setInputFocus = () => {
    myInputRef.current.focus();
    setIsShowSearch(true);
  };

  const focusSearchMobile = () => {
    myInputRef.current.focus();
    setIsShowSearch(true);
    document.body.classList.add("search-bar-open");
  };

  const closeSearchbar = () => {
    setShowMenu && setShowMenu(false);
    setIsShowSearch(false);
    setSearchTextData("");
    document.body.classList.remove("search-bar-open");
  };
  /*******************
   @Purpose : redirect vehicle detail page
   @Parameter : {str}
   @Author : INIC
   *******************/
  const onChangeHandler = (data) => {
    const mobileSlug =
      is_mobile_app === "yes"
        ? (data?.type === "brand" ? "?screen_type=make_details" : "") ||
          (data?.type === "vehical"
            ? "?screen_type=car_details&brand_title=" + data?.label
            : "")
        : "";
    setShowMenu && setShowMenu(false);
    setIsShowSearch(false);
    setSelectedData(data);

    // recent search logic start here
    // setRecentSearch(data);
    // recent search logic end here

    // recently viewed car code start here
    // setRecentlyViewVehicles(data);
    // recently viewed car code end here

    document.body.classList.remove("search-bar-open");
    router.push(data.slugUrl + mobileSlug);
  };

  /*******************
  @Purpose : search brand and vehicle
  @Parameter : {str}
  @Author : INIC
  *******************/
  const handleInputChange = (characterEntered) => {
    setSearchTextData(characterEntered);
    setMakesOptions([]);
    setVehicleOptions([]);

    if (characterEntered.length > 0) {
      setSearchText("Searching...");
    } else {
      setSearchText("");
    }
    debouncedCallApi();
  };

  useEffect(() => {
    if (reload) {
      setReload(false);
      let tempMakesOptions = [];
      let tempVehicleOptions = [];
      setRecentSearchOptions([]);

      if (searchTextData.length > 0) {
        setSearchText("Searching...");

        // call search api
        dispatch(searchBrandVehicle(currentLocationId, searchTextData)).then(
          (res) => {
            if (res.brand.length > 0) {
              res.brand.forEach(function (brand) {
                const slugUrl = hrefURL(brand.slug);
                const obj = {
                  label: brand.title,
                  image: brand?.image?.jpeg_w180,
                  type: "b",
                  slugUrl:
                    slugUrl +
                    (is_mobile_app === "yes"
                      ? "?screen_type=make_details"
                      : ""),
                };
                tempMakesOptions.push(obj);
              });
              setMakesOptions(tempMakesOptions);
            } else {
              setMakesOptions([]);
              setSearchText("No results found");
            }

            if (res.vehicle.length > 0) {
              res.vehicle.forEach(function (row) {
                const vehicleSlugUrl =
                  row.brand_detail.slug +
                  "/" +
                  row.category_detail.slug +
                  "/" +
                  row.slug +
                  "/" +
                  row.slug_id +
                  (is_mobile_app === "yes" ? "?screen_type=car_details" : "");

                const slugUrl = hrefURL(vehicleSlugUrl);

                const obj = {
                  label: row?.name_with_brand,
                  image: row?.primary_image?.image?.thumb,
                  type: "v",
                  vehicleName: row?.name,
                  brandName: row?.brand_detail?.title,
                  mainImage: row?.primary_image?.image?.main,
                  slugUrl: slugUrl,
                };
                tempVehicleOptions.push(obj);
              });
              setVehicleOptions(tempVehicleOptions);
            } else {
              setVehicleOptions([]);
              setSearchText("No results found");
            }
          }
        );
      } else {
        setMakesOptions([]);
        setVehicleOptions([]);
        setSearchText("");
      }
    }
  }, [reload]);

  /*******************
   @Purpose : handle on focus
   @Parameter : {}
   @Author : INIC
   *******************/
  const handleOnFocus = () => {
    setRecentSearchOptions(getRecentSearchList());
  };

  /*******************
   @purpose : Render HTML/ React Components
   @Author : INIC
   ******************/
  return (
    <>
      <div className="position-relative search-bar">
        <div
          className={`custom-search ${isShowSearch && "show-search-bar"}`}
          id="search-results"
        >
          <div className="search-group">
            <Form.Control
              ref={myInputRef}
              type="text"
              name="search"
              id="search"
              placeholder="Search by make or model"
              onClick={setInputFocus}
              value={searchTextData}
              autoComplete="off"
              onChange={(e) => {
                handleInputChange(e.target.value);
              }}
              onFocus={handleOnFocus}
              tabIndex="0"
              autoFocus={showAutofocus}
            />
            <label htmlFor="search" className="center-placeholder">
              <span className="icon-search"></span>Search by make or model
            </label>
            <span className="icon icon-search"></span>
            <Button
              variant="link"
              className="border-0 close-search"
              onClick={closeSearchbar}
              id="close-search"
            >
              <span className="icon-close"></span>
            </Button>

            {/* Selected value preview */}
            {selectedData && (
              <div className="car-listing cursor-pointer preview-car d-none d-md-flex">
                <div className="car-img">
                  <img src={selectedData.image} alt="Brand img" />
                </div>
                <h4>{selectedData.label}</h4>
              </div>
            )}
          </div>

          {(groupedOptions[0].options?.length > 0 || searchTextData) && (
            <div className="result-box">
              <div
                className={`search-results ${
                  isShowSearch ? "d-block" : "d-none"
                }`}
              >
                <ul className="list-unstyled mb-0">
                  {groupedOptions[0].options?.length > 0 && (
                    <li>
                      <strong>{groupedOptions[0].label}</strong>
                      <ul className="list-unstyled mb-0 car-list">
                        {groupedOptions[0].options.map((data, index) => (
                          <li
                            key={data.label + index}
                            onClick={(e) => {
                              onChangeHandler(data);
                            }}
                          >
                            <div className="car-listing cursor-pointer">
                              <div className="car-img">
                                <img src={data.image} alt={data.label} />
                              </div>
                              <h4>{data.label}</h4>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </li>
                  )}

                  {searchTextData && groupedOptions[1].options?.length > 0 && (
                    <li>
                      <strong>{groupedOptions[1].label}</strong>
                      <ul className="list-unstyled mb-0 car-list">
                        {groupedOptions[1].options.map((data, index) => (
                          <li
                            key={data.label + index}
                            onClick={() => onChangeHandler(data)}
                          >
                            <div className="car-listing cursor-pointer">
                              <div className="car-img">
                                <img src={data.image} alt={data.label} />
                              </div>
                              <h4>{data.label}</h4>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </li>
                  )}

                  {searchTextData && groupedOptions[2].options?.length > 0 && (
                    <li>
                      <strong>{groupedOptions[2].label}</strong>
                      <ul className="list-unstyled mb-0 car-list">
                        {groupedOptions[2].options.map((data, index) => (
                          <li
                            key={data.label + index}
                            onClick={() => onChangeHandler(data)}
                          >
                            <div className="car-listing cursor-pointer">
                              <div className="car-img">
                                <img src={data.image} alt={data.label} />
                              </div>
                              <h4>{data.label}</h4>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </li>
                  )}
                  {searchText &&
                    groupedOptions[0].options?.length === 0 &&
                    groupedOptions[1].options?.length === 0 &&
                    groupedOptions[2].options?.length === 0 && (
                      <li className="no-result">{searchText}</li>
                    )}
                </ul>
              </div>
            </div>
          )}
        </div>

        {(asPath === "/" || (slug && slug?.length === 2)) && (
          <div
            className="search-box on-focus d-block d-md-none"
            onClick={focusSearchMobile}
          >
            <div className="box-label">
              <span className="icon icon-search mr-2"></span>
              Search by make or model
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default SearchBar;
